(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyCustomerListV2Controller', CompanyCustomerListV2Controller);

    CompanyCustomerListV2Controller.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService', 'CompanyCustomerCustom', 'pagingParams', 'paginationConstants', '$mdDialog', '$uibModal', 'QueryParamsService', 'CustomerGroupCustom', '$localStorage'];

    function CompanyCustomerListV2Controller($scope, $state, ParseLinks, AlertService, CompanyCustomerCustom, pagingParams, paginationConstants, $mdDialog, $uibModal, QueryParamsService, CustomerGroupCustom, $localStorage) {
        var vm = this;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clearSearch = clearSearch;
        vm.gotoNewReserve = gotoNewReserve;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.search = search;
        vm.searchQuery = pagingParams.search || "";
        vm.currentSearch = pagingParams.search;
        vm.searchKeyPress = searchKeyPress;

        vm.isSearching = false;
        vm.newCustomer = newCustomer;
        vm.editCustomer = editCustomer;
        vm.showEducation = showEducation;
        vm.showFilterDialog = showFilterDialog;
        vm.advancedSearch = advancedSearch;
        vm.filterCompnayCustomers = filterCompnayCustomers;
        vm.filterCompanyCustomers_global = filterCompanyCustomers_global;
        vm.clear = clear;
        vm.filterQuery = {};
        vm.filterCount = 0;
        vm.customerGroups = [];
        vm.getCompanyCustomerDuplicatesItems = [];
        vm.showDuplicatesBanner = undefined;
        vm.closeDuplicatesBanner = closeDuplicatesBanner;
        $scope.modelValue = false;
        vm.showDuplicatesModal = showDuplicatesModal;

        var dialog = document.querySelector(
            'panel-pln-merge-duplicates-dialog'
        );
        dialog.modelValue = $scope.modelValue;

        dialog.addEventListener('update:modelValue', function (event) {
            $scope.$apply(function () {
                $scope.modelValue = false;
            });
        });
         dialog.addEventListener('submitted', function (event) {
            $scope.$apply(function () {
                vm.getCompanyCustomerDuplicates();
            });
        });
        $scope.$watch('modelValue', function(newVal) {
            if (dialog.modelValue !== newVal) {
                dialog.modelValue = newVal;
            }
        });

        function showDuplicatesModal(){
            $scope.modelValue = true;
        }

        $scope.filters = QueryParamsService.getFilters();
        loadAll_paging();

        function loadAll_paging() {
            getCompanyCustomerDuplicates()
            getCustomerGroups()
            getQueryParams();
            vm.filterCompnayCustomers();
            setDefaultShowDuplicatesBanner()
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            // $state.transitionTo($state.$current, {
            //     page: vm.page,
            //     sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
            //     query: vm.searchQuery
            // });
            if (vm.filterQuery.searchMode)
                getCompanyCustomersByQuery(vm.filterQuery);
            else
                getCompanyCustomersByQuery();
            
        }


        function clearSearch() {
            vm.filterQuery.query = null
            filterCompanyCustomers_global();
            QueryParamsService.removeFilter('query')
        }

        function gotoNewReserve(customerId) {

            $state.go('supplierPanel-v2.reserveWithCustomerParameter', {
                customerId: customerId
            });


        }


        function search(searchQuery) { 
            if (!searchQuery) {
                return vm.clear();
            }
            if (vm.isSearching)
                return;
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                search();
            }
        }

        function newCustomer() {
            $state.go('supplierPanel-v2.companyCustomer.new')
        }

        function editCustomer(companyCustomer) {
            // $state.go('supplierPanel-v2.companyCustomer.edit', {id: companyCustomer.id});
            $state.go('supplierPanel-v2.companyCustomer.edit', {id: companyCustomer.id});
        }

        function showEducation() {
            $uibModal.open({
                templateUrl: 'app/components/modal/educationMovie.html',
                controller: 'EducationMovieController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    link: function () {
                        return '<div id="89680098133"><script type="text/JavaScript" src="https://www.aparat.com/embed/lvxdy6c?data[rnddiv]=89680098133&data[responsive]=yes&titleShow=true&autoplay=true"></script></div>'
                    },
                }
            }).result.then(function () {
                // $state.go('^');
            }, function () {
                // $state.go('^');
            });
        }
        function getQueryParams() {
            var newFilters = QueryParamsService.getFilters();
            if (newFilters.page) {
                pagingParams.search = parseInt(newFilters.page, 10) - 1;
                vm.page = parseInt(newFilters.page, 10);
            }
            if(newFilters.size){
                vm.size = newFilters.size;
            }
            if(newFilters.query){
                vm.filterQuery.query = newFilters.query;
            }
            if(newFilters.filterQuery) {
                setFilterQuery(JSON.parse(decodeURIComponent(newFilters.filterQuery)))
            }
          
        }
        function advancedSearch() {
            clear();
            vm.filterQuery.searchMode = true;
            vm.filterQuery.dontFilterFromDate = false;
            filterCompnayCustomers();
        }
        function showFilterDialog() {
            // if(!vm.companyCustomers.length) return
            var dialogData_ = {};
            dialogData_.companyCustomers = vm.companyCustomers;
            dialogData_.filterQuery = vm.filterQuery;

            $mdDialog.show({
                locals: {dialogData: dialogData_},
                controller: ShowFilterDialogController,
                templateUrl: 'app/entities/company-customer/filter-company-customer-list-dialog.html',
                controllerAs: '$ctrl',
                parent: angular.element(document.body),
                targetEvent: dialogData_,
                clickOutsideToClose: true,
                
                fullscreen: false

            })
            .then(function (data) {
                setFilterQuery(data.filterQuery, true);
                QueryParamsService.updateFilter('filterQuery', encodeURIComponent(JSON.stringify(data.filterQuery)))
                vm.advancedSearch();
            }, function () {
            });
        }
        function setFilterQuery(filter, ignorQuery) {
            var shallowFilter = filter
            if(ignorQuery &&  shallowFilter.query) delete shallowFilter.query
            if(filter.groupIds && filter.groupIds.includes('1')) {
                vm.filterQuery["includeUngrouped"] = true;
            }else delete vm.filterQuery["includeUngrouped"]
            angular.extend(vm.filterQuery, filter);
            countFilters(filter);
        }
        function countFilters(filter) {
            vm.filterCount = 0;
            if (filter.customerFullName)
                vm.filterCount++;
            if (filter.groupIds && filter.groupIds.length)
                vm.filterCount++;
            if(vm.filterCount < 1) 
                QueryParamsService.removeFilter('filterQuery')
        }
        
        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            // vm.reverse = true;
            vm.currentSearch = null;
            vm.filterQuery.page = 0;
            vm.transition();
        }
        function filterCompnayCustomers(customFilter) { 
            if (vm.isSearching)
                return;
            getCompanyCustomersByQuery(customFilter);
        }
        function getCompanyCustomersByQuery(customFilter) {
            if (vm.isSearching)
                return;

            vm.isSearching = true;
            var filterQuery = vm.filterQuery;
            if (customFilter)
                filterQuery = customFilter;

            if (vm.page)
                filterQuery.page = vm.page - 1;
            else
                filterQuery.page = 0;
            //must set in cache
            filterQuery.size = vm.size; // paginationConstants.itemsPerPage;
            // paginationConstants.itemsPerPage = vm.size;
            searchCompanyCustomersByQueryPage(filterQuery)
        }
        function searchCompanyCustomersByQueryPage(filterQuery) {
            // {
            //     query: vm.searchQuery,
            //     page: pagingParams.page - 1,
            //     size: paginationConstants.itemsPerPage,
            //     sort: sort()
            // }
            CompanyCustomerCustom.getAllCompanyCustomers().query(filterQuery, onSuccess, onError);
            

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.isSearching = false;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.companyCustomers = data;
                // vm.page = pagingParams.page;
            }

            function onError(error) {
                vm.isSearching = false;
                AlertService.error(error.data.message);
            }
        }
        function getCustomerGroups() {
             CustomerGroupCustom
                .getCustomerGroupsByCurrentCompany()
                .query()
                .$promise
                .then(function (items) {
                     vm.customerGroups = items || [];
                })
                .catch(function(error) {
                    console.error('Company customer request failed:', error);
                });
        }
        function filterCompanyCustomers_global() {
             if (vm.filterQuery.query) {
                vm.filterQuery.searchMode = true;
                vm.filterQuery.dontFilterFromDate = true;
                QueryParamsService.updateFilter('query', vm.filterQuery.query)
            } else {
                vm.filterQuery.searchMode = true;
                vm.filterQuery.dontFilterFromDate = false;
                QueryParamsService.removeFilter('query')
            }
            filterCompnayCustomers();
            clear();
        }

        function getCompanyCustomerDuplicates() {
            CompanyCustomerCustom.getCompanyCustomerDuplicates().query().$promise.then(function(res) {
                vm.getCompanyCustomerDuplicatesItems = res;
                dialog.rows = res;
            }).catch(function(err) {
                console.log(err);
            })
        }
        function setDefaultShowDuplicatesBanner(){
           if($localStorage.showDuplicatesBanner === undefined) {
            vm.showDuplicatesBanner = true
           }
            else {
                var item = $localStorage.showDuplicatesBanner;
                if(Date.now() > item.expiry) {
                    vm.showDuplicatesBanner = true;
                    $localStorage.showDuplicatesBanner = {
                        value: true,
                        expiry:  Date.now() + (1 * 60 * 60 * 1000)
                    }
                }else vm.showDuplicatesBanner = item.value;
            }
                
           
        }
        function closeDuplicatesBanner() {
            $localStorage.showDuplicatesBanner = {
                value: false,
                expiry:  Date.now() + (1 * 60 * 60 * 1000)
            }
            vm.showDuplicatesBanner = false;
        }

           var ShowFilterDialogController = function ($scope, $mdDialog, dialogData, $mdSelect) {
            var $ctrl = this;
            $ctrl.data = dialogData;
            $ctrl.okModal = okModal;
            $ctrl.closeModal = closeModal;
            $ctrl.clearFilter = clearFilter;
            $ctrl.customerGroups = vm.customerGroups;

            //for closing the select box
            document.body.onclick = function (e) {
                $mdSelect.hide();
            }

            function okModal() {
                $mdDialog.hide($ctrl.data);
            }

            function closeModal() {
                $mdDialog.cancel();
            }

            function clearFilter() {
                $ctrl.data.filterQuery = {};
                delete vm.filterQuery.customerFullName;
                delete vm.filterQuery.groupIds;
            }

        };
        ShowFilterDialogController.$inject = ['$scope', '$mdDialog', 'dialogData', '$mdSelect'];
    }
})();
